import { Ability } from '@casl/ability'
import React from 'react'

const AbilityContext = React.createContext<Ability | undefined>(undefined)

export default AbilityContext
